export const EditPromotion = {
  "id": 41301988,
  "restaurantId": "16000106",
  "creationDate": 1498038929018,
  "name": "3 Pizzas achetées = 1 offerte",
  "description": "Lors de l'achat de 3 pizzas à emporter, la moins chère des 3 est offerte",
  "code": null,
  "combinable": false,
  "priority": 0,
  "enabled": true,
  "archived": false,
  "condition": {
    "orderModes": [
    1,2
    ],
    "frontCondition": {
      "apiConsumerIds": null,
      "platforms": null
    },
    "dateCondition": {
      "beginningDate": 1498038929018,
      "endDate": 1598038929018,
      "weeklyAvailabilities": null
    },
    "amountCondition": {
      "minOrderAmount": 0,
      "includeShippingCostInMinOrderAmount": false,
      "maxOrderAmount": 0,
      "includeShippingCostInMaxOrderAmount": false,
      "maxOrderAmountToApplyOn": 0,
      "includeShippingCostInMaxOrderAmountToApplyOn": false
    },
    "userCondition": {
      "ids": null,
      "emailAddresses": null,
      "restaurantsGroupId": null
    },
    "numberOfUseCondition": {
      "maxNumberOfUses": 0,
      "maxNumberOfUsesPerUser": 0
    },
    "itemCondition": {
      "itemsRequired": [
      {
        "itemsNumber": 3,
        "itemsList": [
        {
          "type": 0,
          "id": "1475508813_1239d"
        },
        {
          "type": 2,
          "id": "58CE1331-783F-4BFC-BD13-800FF2112FD8"
        },
        {
          "type": 2,
          "id": "4DCC684A-2181-4772-8CDE-D627821EF499"
        },
        ]
      }
      ],
      "itemsForbidden": null
    }
  },
  "target": {
    "type": "SHIPPING_COST",
    "items": null
  },
  "action": {
    "type": "DISCOUNT_PERCENTAGE",
    "value": 100
  }
}

export const NewPromotion = {
  "id": null,
  "restaurantId": null,
  "creationDate": null,
  "name": "",
  "description": "",
  "code": null,
  "combinable": false,
  "priority": 0,
  "enabled": true,
  "archived": false,
  "condition": {
    "orderModes": [
    ],
    "frontCondition": {
      "apiConsumerIds": null,
      "platforms": null
    },
    "dateCondition": {
      "beginningDate": null,
      "endDate": null,
      "weeklyAvailabilities": null,
    },
    "amountCondition": {
      "minOrderAmount": 0,
      "includeShippingCostInMinOrderAmount": false,
      "maxOrderAmount": 0,
      "includeShippingCostInMaxOrderAmount": false,
      "maxOrderAmountToApplyOn": 0,
      "includeShippingCostInMaxOrderAmountToApplyOn": false
    },
    "userCondition": {
      "ids": null,
      "emailAddresses": null,
      "restaurantsGroupId": null
    },
    "numberOfUseCondition": {
      "maxNumberOfUses": 0,
      "maxNumberOfUsesPerUser": 0
    },
    "itemCondition": {
      "itemsRequired": null,
      "itemsForbidden": null
    }
  },
  "target": {
    "type": null,
    "items": null,
  },
  "action": {
    "type": null,
    "value": null
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/order/cartModifiers/fixture.js